import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ overline, title, subtitle, align = "left", light = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {overline && <p className="overline mb-4">{overline}</p>}
      <h2 className={`font-serif text-4xl md:text-5xl font-light leading-tight tracking-tight ${light ? "text-white" : "text-[#EFE7FA]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base md:text-lg font-light leading-relaxed ${light ? "text-white/75" : "text-[#EFE7FA]/70"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
